import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BaasicFieldDropdown, BaasicButton } from 'core/components';

function FacilityOrderExtraSuppliesAddModalTemplate({ facilityOrderExtraSuppliesAddModalViewStore , t}) {
    const {
        form,
        subCategoryStore,
        modalParams
    } = facilityOrderExtraSuppliesAddModalViewStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Add Extra Supplies</h3>
            </div>
            <div className="modal__body">
                <div className="form__group">
                    <BaasicFieldDropdown field={form.$('subCategoryId')} store={subCategoryStore} />
                </div>
            </div>
            <div className='modal__footer'>
                <BaasicFormControls
                    form={form} 
                    onSubmit={form.onSubmit} 
                    disabled={form.submitting || form.validating} 
                    className='btn btn--med btn--primary'
                    label="Create"
                />  
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
            </div>
        </section> 
    )
}
 
FacilityOrderExtraSuppliesAddModalTemplate.propTypes = {
    facilityOrderExtraSuppliesAddModalViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityOrderExtraSuppliesAddModalTemplate);